import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  GridList,
  GridListTile,
  GridListTileBar,
  Icon,
  IconButton,
} from '@material-ui/core';

import './Landing.css';

function LoginDialog (props) {
  const dialogTitle = props.error ?
    'Authorization Error':
    'Welcome to WODScreen!';

  const dialogContent = props.error ?
    'Authorization attempt unsuccessful. Please try again' :
    'Click the button below to authorize WODScreen to access your gym.';

  const returnUri = `${window.location.origin}${window.location.pathname}?${window.location.search}`;
  const loginUrl = `https://www.beyondthewhiteboard.com/session/jwt/_coaching_team_1?to=${returnUri}`;

  return (
    <Dialog
      open={props.open}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>{dialogContent}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" href={loginUrl}>Authorize</Button>
        </DialogActions>
    </Dialog>
  );
};

class Landing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
      error: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.route !== nextProps.route) {
      return this.props.history.push(nextProps.route);
    }

    if (!nextProps.gym.loading && !nextProps.gym.display_name) {
      this.setState({
        dialogOpen: true,
        error: false,
      });
    } else if (!nextProps.gym.loading && nextProps.gym.error) {
      this.setState({
        dialogOpen: true,
        error: true,
      });
    } else {
      this.setState({
        dialogOpen: false,
        error: false,
      });
    }
  }

  render() {
    const screenData = [
      /*{
        name: 'Open Leaderboard',
        route: '/open-leaderboard',
        img: 'https://wodscreen.com/imgs/leaderboard.png',
      },*/
      {
        name: 'Daily WOD',
        route: '/daily-wod-2',
        img: 'https://crossfit.btwb.com/media/daily-wod-tv.png',
        description: "Displays today's WODs (or yesterday's if none are planned for today), as well as the top 3 performers and the average scores for each.",
      },
      {
        name: 'Activity Feed',
        route: '/activity-feed-2',
        img: 'https://crossfit.btwb.com/media/activity_feed_v2-tv.png',
        description: "Displays recent member activity, today's WODs, and statistics on how your gym is performing for each."
      },
      {
        name: 'Daily WOD (Legacy)',
        route: '/daily-wod',
        img: 'https://wodscreen.com/imgs/receiver.png',
        description: "Displays today's WODs (or yesterday's if none are planned for today), as well as the top 3 performers and the average scores for each."
      },
      {
        name: 'Activity Feed (Legacy)',
        route: '/activity-feed',
        img: 'https://wodscreen.com/imgs/receiver.png',
        description: "Displays recent member activity, today's WODs, and statistics on how your gym is performing for each."
      },
      {
        name: 'Committed Club',
        route: 'https://wodscreen.com/committed-club/webcast/index.html',
        img: 'https://wodscreen.com/imgs/committed-club.png',
      },
      {
        name: 'PR Board',
        route: 'https://wodscreen.com/pr-board/webcast/index.html',
        img: 'https://wodscreen.com/imgs/pr-board.png',
      },
      {
        name: 'Leaderboard',
        route: 'https://wodscreen.com/leaderboard/webcast/index.html',
        img: 'https://wodscreen.com/imgs/leaderboard.png',
      },
    ];

    return(
      <>
        <div className="pa3">
          <h1 className="tc">WODScreen</h1>
          <p className="tc mb4">Choose a screen to display from the list below.</p>
          <div className="screenContainer">
            <GridList cellHeight='auto' spacing={64}>
              {screenData.map((screen, idx) => (
                <GridListTile key={idx}>
                  <img src={screen.img} alt={screen.name} style={{width: 'auto', height: 'auto'}} />
                  <GridListTileBar
                    className="fw6"
                    title={screen.name}
                    subtitle={screen.description}
                    actionIcon={
                      <IconButton onClick={this.props.changeRoute.bind(this, screen.route)}>
                        <Icon className="pr1 fas fa-external-link-alt" fontSize="small" style={{
                          color: 'white'
                        }} />
                      </IconButton>
                    }
                    classes={{
                      title: 'tile-bar-title',
                      subtitle: 'tile-bar-subtitle',
                      root: 'tile-bar-root'
                    }}
                  />
                </GridListTile>
              ))}
            </GridList>
          </div>
        </div>
        <LoginDialog open={this.state.dialogOpen} error={this.state.error} />
      </>
    )
  }
}

Landing.propTypes = {
  themeColor: PropTypes.string.isRequired,
  gym: PropTypes.object.isRequired,
  changeRoute: PropTypes.func.isRequired
}

export default Landing;